import { Box } from '@fe-toolkit/web-components/ssr'
import { useState } from 'react'

import { SubMenuNav } from './SubMenu.styled'

const SubMenu = () => {
  const [isOpen, setOpen] = useState(false)

  return (
    <Box backgroundColor="black" color="white">
      <SubMenuNav aria-label="account-navigation">
        <ul>
          <li className="active">
            <button aria-label="Toggle menu" type="button" onClick={() => setOpen(!isOpen)}>
              <span>{isOpen ? '—' : '+'}</span> Account
            </button>
            <a href="/dashboard">Account</a>
          </li>
          <li className={!isOpen ? 'toggleable' : ''}>
            <a href="/profile/details">Profile and settings</a>
          </li>
          <li className={!isOpen ? 'toggleable' : ''}>
            <a href="/profile/payment-details">Orders and payments</a>
          </li>
          <li className={!isOpen ? 'toggleable' : ''}>
            <a href="/profile/security">Security</a>
          </li>
          <li className={!isOpen ? 'toggleable' : ''}>
            <a href="/profile/my-loans">Loans</a>
          </li>
          <li className={!isOpen ? 'toggleable' : ''}>
            <a href="/first-steps">Get started</a>
          </li>
        </ul>
      </SubMenuNav>
    </Box>
  )
}

export default SubMenu
